/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Step_Label_CompanyInputs */

const es_co2_signup_step_label_company = /** @type {(inputs: Signup_Step_Label_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empresa`)
};

/**

* @param {Signup_Step_Label_CompanyInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_step_label_company = /** @type {((inputs?: Signup_Step_Label_CompanyInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Step_Label_CompanyInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_step_label_company(inputs)
});